import { View, TouchableOpacity, Linking } from "react-native";
import { useThemedStyleFunction } from "../theme-provider";
import { socialMediaStyle } from "./social-media-list.style";
import { SocialMedia } from '../../interfaces';
import { socialMediaIcons } from '../../utils'

type SocialMediaListProps = SocialMedia & {
    renderRightButton?: () => React.ReactNode;
};
  
const SocialMediaList = ( props: SocialMediaListProps) => {
    const { renderRightButton, ...socialMediaProps } = props;
    const style = useThemedStyleFunction(socialMediaStyle);

    // Stored links may or may not include a protocol – only add one when missing.
    const handleOpenLink = (url: string) => Linking.openURL(/^https?:\/\//i.test(url) ? url : `https://${url}`);

    return (
        <View style={style.container}>
            <View style={style.leftContent}>
                {Object.entries(socialMediaProps).map(([key, value]: [string, string | undefined]) => {
                    if (!value || !socialMediaIcons[key]) return null;

                    return (
                    <TouchableOpacity key={key} onPress={() => handleOpenLink(value)} style={style.iconWrapper}>
                        {socialMediaIcons[key]}
                    </TouchableOpacity>
                    );
                })}
            </View>
            {renderRightButton && (
                <View style={style.rightContent}>
                    {renderRightButton()}
                </View>
            )}
        </View>
    );
};
  
export { SocialMediaList };